import React from "react";
import { MessageCircle, Mail, Building, Banknote, Instagram, Facebook, Users, Youtube, Twitter } from "lucide-react";
import PageTransition from "../components/PageTransition";
import SocialStrip, { SOCIAL_KEYS } from "../components/SocialStrip";
import ExtraContacts from "../components/ExtraContacts";
import { useApp } from "../context/AppContext";

const Contact = () => {
    const { t, settings } = useApp();
    const wa = settings.whatsapp_number ? `https://wa.me/${settings.whatsapp_number}` : "#";
    const anySocial = SOCIAL_KEYS.some((k) => settings[k]);

    return (
        <PageTransition>
            <div className="max-w-5xl mx-auto px-6 lg:px-10 py-24">
                <div className="ornament-divider mb-8"><span className="font-arabic text-3xl text-gold">۞</span></div>
                <h1 className="font-serif text-5xl mb-4">{t("nav.contact")}</h1>
                <p className="text-muted_green mb-12">Rezervasyon, fiyat teklifi ve tüm sorularınız için bize ulaşın.</p>

                <div className="grid md:grid-cols-2 gap-px bg-border_green mb-12">
                    <a href={wa} target="_blank" rel="noreferrer" className="bg-emerald_surface p-10 hover:bg-emerald_hover transition-colors" data-testid="contact-whatsapp">
                        <MessageCircle className="w-8 h-8 text-gold mb-4" />
                        <h3 className="font-serif text-2xl mb-2">WhatsApp</h3>
                        <p className="text-bone/70">+{settings.whatsapp_number}</p>
                    </a>
                    <a href={`mailto:${settings.contact_email}`} className="bg-emerald_surface p-10 hover:bg-emerald_hover transition-colors" data-testid="contact-email">
                        <Mail className="w-8 h-8 text-gold mb-4" />
                        <h3 className="font-serif text-2xl mb-2">E-posta</h3>
                        <p className="text-bone/70">{settings.contact_email}</p>
                    </a>
                    <div className="bg-emerald_surface p-10">
                        <Building className="w-8 h-8 text-gold mb-4" />
                        <h3 className="font-serif text-2xl mb-2">{settings.company_name}</h3>
                        <p className="text-bone/70">Türkiye Merkez Ofis</p>
                    </div>
                    <div className="bg-emerald_surface p-10">
                        <Banknote className="w-8 h-8 text-gold mb-4" />
                        <h3 className="font-serif text-2xl mb-2">Banka / IBAN</h3>
                        <p className="text-bone/70 text-sm">{settings.bank_name}</p>
                        <p className="text-bone font-mono text-sm mt-1">{settings.iban}</p>
                        <p className="text-bone/70 text-xs mt-1">{settings.account_holder}</p>
                    </div>
                </div>

                {(settings.extra_contacts || []).length > 0 && (
                    <div className="mb-12" data-testid="contact-extra-section">
                        <div className="text-xs uppercase tracking-[0.3em] text-gold mb-3">Ek İletişim</div>
                        <h2 className="font-serif text-3xl mb-6">Diğer Kanallar</h2>
                        <ExtraContacts items={settings.extra_contacts} />
                    </div>
                )}

                {anySocial && (
                    <div data-testid="contact-social-section">
                        <div className="text-xs uppercase tracking-[0.3em] text-gold mb-3">Sosyal Medya & Topluluk</div>
                        <h2 className="font-serif text-3xl mb-6">Bizi takip edin</h2>
                        <SocialStrip settings={settings} compact />
                    </div>
                )}
            </div>
        </PageTransition>
    );
};

export default Contact;
